import { line, lineName, subline } from '~/helpers/fields-description';
import { FieldObject } from '~/interfaces/field.interface';
import { NAModule } from '../NAModule.model';

export class NLEModule extends NAModule {
    hasOperationDissociate = false;
    hasOperationReset = false;
    hasOperationImportData = false;

    consumption_type?: string;
    channel?: number;
    isWired = true;

    get fieldId(): FieldObject | undefined {
        return undefined;
    }
    get fieldName(): FieldObject | undefined {
        return undefined;
    }
    get fieldType(): FieldObject | undefined {
        return undefined;
    }
    get fieldSetupDate(): FieldObject | undefined {
        return undefined;
    }
    get fieldFirmware(): FieldObject | undefined {
        return undefined;
    }
    get fieldLastUpdate(): FieldObject | undefined {
        return undefined;
    }
    get fieldLastSetup(): FieldObject | undefined {
        return undefined;
    }
    get fieldRoom(): FieldObject | undefined {
        return undefined;
    }
    get fieldRefurbished(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand(): FieldObject | undefined {
        return undefined;
    }
    get fieldCustomer2(): FieldObject | undefined {
        return undefined;
    }
    get fieldCommand2(): FieldObject | undefined {
        return undefined;
    }
    get fieldLine() {
        return line(this.consumption_type);
    }
    get fieldSubline() {
        return subline(this.getLineName(null, this.channel));
    }
    get fieldLineName() {
        return lineName(this.getLineName(this.name, this.channel));
    }

    getLineName(name: string | null, channel?: number): string {
        if (!name) {
            switch (channel) {
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    name = `Line ${channel + 1}`;
                    break;
                case 5:
                    name = 'Total';
                    break;
                case 6:
                    name = 'Gas';
                    break;
                case 7:
                    name = 'Hot water';
                    break;
                case 8:
                    name = 'Cold water';
                    break;
            }
        }
        return name as string;
    }

    get shouldShowDevice(): boolean {
        return true;
    }
}
